import * as React from 'react';
import {connect} from 'react-redux';
import {Dispatch} from 'redux';
import {Header, Icon} from '@openfin/desktop-ui';

import {RootState} from '../../../store/State';
import {getMemberInfos, ToggleChannelManagerWindow, MemberInfo} from '../../../store/partials/ChannelManager';
import * as ChannelManagerIcon from '../../../assets/ChannelManager.svg';
import * as NoMemberIcon from '../../../assets/NoMember.svg';

import * as Styles from './ChannelManagerApp.module.scss';
import {ChannelAppInfo} from './ChannelAppInfo';
import {ChannelSelector} from './ChannelSelector';
import {ChannelSelectorHeader} from './ChannelSelectorHeader';

interface Props {
    channelMembers: MemberInfo[];
    onClose: () => void;
}

const ChannelManagerComponent: React.FC<Props> = React.memo((props) => {
    const {channelMembers, onClose} = props;

    return (
        <div className={Styles['channel-manager-view']}>
            <Header className={Styles['header']} onClose={onClose} text="Channel Manager" image={ChannelManagerIcon} />
            {(channelMembers.length > 0)
                ? <div className={Styles['list']}>
                    <div className={Styles['left-pane']}>
                        <ChannelAppInfo
                            header={true}
                            appName="Application"
                            appTitle="Window Title" />
                        {channelMembers.map((member, i) => <ChannelAppInfo
                            key={i}
                            appName={member.display.application}
                            appIcon={member.display.icon}
                            appTitle={member.display.name} />)}
                    </div>
                    <div className={Styles['right-pane']}>
                        <ChannelSelectorHeader />
                        {channelMembers.map((member, i) => <ChannelSelector key={i} app={member} />)}
                    </div>
                </div>
                : <div className={Styles['no-members-message']}>
                    <Icon src={NoMemberIcon} />
                    <h1>No Applications Running</h1>
                    <span>Start running applications to see their channels</span>
                </div>}
        </div>
    );
});

const mapState = (state: RootState) => ({
    channelMembers: getMemberInfos(state)
});

const mapDispatch = (dispatch: Dispatch) => ({
    onClose: () => {
        dispatch(new ToggleChannelManagerWindow());
    }
});

export const ChannelManagerApp = connect(mapState, mapDispatch)(ChannelManagerComponent);
